
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/embedding",
      function () {
        return require("private-next-pages/signature/embedding/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signature/embedding"])
      });
    }
  